import Vue from 'vue'
import Vuex from 'vuex'
import moment from "moment";
import themeConfig from '@/../themeConfig.js'
import mails from '@/views/apps/email/emails'

Vue.use(Vuex)
/* eslint-disable */

export default new Vuex.Store({

  state: {
    theme: themeConfig.theme,    
  	isSidebarActive: false,
  	isSidebarReduced: themeConfig.sidebarCollapsed,
  	sidebarWidth: "default",
    themeColor: themeConfig.themeColor,

    // Calendar Events
    calendarEvents: [{
      title: "test",
      allDay: true,
      start: moment(),
      end: moment().add(1, "d")
    }],

    // Email States
    emails: mails,
    filtered_mail: "Inbox",
    countries:0,
    stadiums: 0,
        statsCountries: [],
        stadiumList: [],
    //Autentica��o
    isAuthenticated:false,
        nextRoute: "",
        SurveyStruct: [],
        SurveyScoreTable: [],
        SelectedSurvey: 0
  },
    mutations: {
        SET_SurveyScoreTable(state, n) {
            state.SurveyScoreTable = n;
        },
        SET_SurveyStruct(state, n) {
            state.SurveyStruct = n;
        },
        SET_SelectedSurvey(state, n) {
            state.SelectedSurvey = n;
        },
        SET_Countries(state, n) {                       
            state.countries = n;
        },
        SET_stadiums(state, n) {            
            state.stadiums = n;
        },
        SET_stadiumList(state, l) {
            state.stadiumList = l;
        },
        SET_Login(state) {            
            state.isAuthenticated = true;   
            
        },
        SET_Logout(state){
            state.isAuthenticated = false;
        },
        SET_NextRoute(state, to) {
            state.nextRoute = to;
        },
  	//This is for Sidbar trigger in mobile
  	IS_SIDEBAR_ACTIVE(state, value) {
        state.isSidebarActive = value;
    },
    //This is for Sidebar toggle in desktop
    TOGGLE_REDUCE_SIDEBAR(state, val) {
        state.isSidebarReduced = val;
    },
    //This is for Themeset
    SET_THEME(state, val) {
        state.theme = val;
    },
    //This is for Theme color
    SET_THEME_COLOR(state, val) {
        state.themeColor = val;
    },
    SET_SIDEBAR_WIDTH(state, width) {
        state.sidebarWidth = width;
    },
    // Add Calendar event
    ADD_CALENDAR_EVENT(state, event) {
      const newEvent = Object.assign({}, event);
      state.calendarEvents.push(newEvent);
    },

    // Filter emails
    FILTERED_MAIL(state, filterCategory) {
      state.filtered_mail = filterCategory
    },
  },  
  actions: {
  	updateSidebarWidth({ commit }, width) {
        commit('SET_SIDEBAR_WIDTH', width);
    },
    //Calendar Action 
    addCalendarEvent({ commit }, event) {
        commit('ADD_CALENDAR_EVENT', event);
    },
    
    // Email Action
    filteredMail({ commit }, filterCategory){
        commit('FILTERED_MAIL', filterCategory)
    }
  },
  getters:{
    // Get Filtered Email
    getFilteredMails: state => state.emails.filter((email) => {
      if (state.filtered_mail == 'Inbox') return email.mail_type == "inbox";
      if (state.filtered_mail == 'Spam') return email.mail_type == "spam"; 
      if (state.filtered_mail == 'Draft') return email.mail_type == "draft";
      if (state.filtered_mail == 'Sent') return email.mail_type == "sent";
    }),
    getCurrentMail: state => (emailId) => state.emails.filter((email) => email.id == emailId)[0],
    getInboxCount: state => state.emails.filter((email) => email.mail_type == 'inbox').length,
  }
})

//export default store
